import PageTest from './pageTest';
import Reference from './Reference';
//import { useAppSelector, useAppDispatch } from '../app/hooks';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import NotConnectedPage from './NotConnectedPage';
import ConnectedPage from './ConnectedPage';
import {
	selectIsAuthenticated,
} from '../features/auth/session/sessionSlice';

export function Home() {
	let now = new Date();
	const session = useSelector(selectIsAuthenticated(now));
	if (session) {
		return (
			<ConnectedPage />
		);
	} else {
		return (
			<NotConnectedPage />
		);
	}
	/*
	return (
		<div>
			<p>This is home ! ! !</p>
			<Link to={"debug/style"}>debug/Style</Link> -
			<Link to={"page/"}>Pages</Link> - 
			<Link to={"page/view/14"}>Pages View</Link> - 
			<Link to={"page/list"}>Pages List</Link> - 
			<Link to={"ticket/"}>Tickets</Link> - 
			<Link to={"auth/authorized"}>auth/authorized</Link> - 
			<Link to={"auth/new-user-form"}>auth/new-user-form</Link> - 
			<br />
			<Reference />
			<PageTest />
			<PageTest />
			<PageTest />
			<PageTest />
			<PageTest />
		</div>

	);
	// */
}
